import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink, from, Observable } from 'apollo-link'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { createApolloFetch } from 'apollo-fetch'
import { message, Modal } from 'antd'
import { Queries } from '../graphql'
import { setToken, getToken, clearAllStorage } from '../utils/auth'
import { ErrorMessageFormAPIApollo } from '../utils/checkError'
import { apiKeyNews } from '../utils/apiKey'
import React from 'react'
import { alertMessage } from '../utils/message'


const checkLinkURL = () =>{
	if(window.location.href.includes("https://vtrc.redcross.or.th/")){
		return "https://vtrcapi.redcross.or.th/api/graphql"
		// return "https://vtrcapi.redcross.or.th/backup-site/graphql"
		// return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql"
	}else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
		// return "https://vtrcapi.redcross.or.th/api/graphql"
		// return "https://vtrcapi.redcross.or.th/backup-site/graphql"
		return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql"
	}else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
		// return "http://10.188.128.162:8081/api-uat/graphql"
		// return "https://vtrcapi.redcross.or.th/api/graphql"
		// return "https://vtrcapi.redcross.or.th/backup-site/graphql"
		return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql"

		// return "http://192.168.0.137:8081/api-uat/graphql"
	}
}


const apolloFetch = createApolloFetch({ uri: checkLinkURL() })
const uploadLink = createUploadLink({ uri: checkLinkURL() })

apolloFetch.use(({ request, options }, next) => {
	const API_DEVICE_KEY = atob(apiKeyNews())
	options.headers = {
		apiKey: API_DEVICE_KEY
	};
	next();
});

const authLink = setContext((_, { headers }) => {
	const { token } = getToken()
	// const API_DEVICE_KEY = apiKeyNews()
	const API_DEVICE_KEY = atob(apiKeyNews())
	if (token) {
		return {
			headers: {
				...headers,
				Authorization: `Bearer ${token}`,
				apiKey : API_DEVICE_KEY
			}
		}
	}
	
	return {
		headers: {
			apiKey : API_DEVICE_KEY
		}
	}
})

const errorLink = onError(({ graphQLErrors, operation, forward }) => {
	// console.log = console.warn = console.error = () => { };
	if (graphQLErrors && graphQLErrors[0].extensions.code === 'TOKEN_EXPIRED') {
		return new Observable(async observer => {
			const oldHeaders = operation.getContext().headers
			const { errors, data } = await apolloFetch({
				query: Queries.refreshToken,
				variables: {
					refreshToken: getToken().refreshToken,
					token: getToken().token
				},
			})
			if (!errors) {
				setToken(data.refreshToken)
				operation.setContext({
					headers: {
						...oldHeaders,
						Authorization: `Bearer ${data.refreshToken.accessToken}`
					}
				})
				const subscriber = {
					next: observer.next.bind(observer),
					error: observer.error.bind(observer),
					complete: observer.complete.bind(observer)
				}
				forward(operation).subscribe(subscriber)
			} else if (errors && errors[0].extensions.code === 'TOKEN_INVALID') {
				alertMessage("error",graphQLErrors[0].message)
				// message.error('Your account has been disabled, please contact administrator.')
				clearAllStorage()
				window.location.href = '/login'
			}
		})
	}

	console.log('graphQLErrors', graphQLErrors)

	if(graphQLErrors){
		if(graphQLErrors && graphQLErrors[0].extensions.code  === 'TOKEN_INVALID'){
         alertMessage("error",graphQLErrors[0].message)
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else if(
			graphQLErrors && graphQLErrors[0].extensions.code === 'SESSION_EXPIRED' ||
			graphQLErrors && graphQLErrors[0].extensions.code === 'SESSION_INVALID' 
		){
         alertMessage("error",graphQLErrors[0].message)
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else if(graphQLErrors && graphQLErrors[0].extensions.code === 'AUTH_LIMIT'){
			// message.error(graphQLErrors[0].message)
			alertMessage("error",graphQLErrors[0].message)
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else if(graphQLErrors && graphQLErrors[0].extensions.code  === 'PROFILE_INVALID' || graphQLErrors[0].extensions.code == 'VERIFY_CODE_INVALID'){
			// alertMessage("error",graphQLErrors[0].message)
			// message.error(graphQLErrors[0].message)
			if(graphQLErrors[0].extensions.remainingCount){
				message.error(graphQLErrors[0].message+' (ระบุได้อีก '+graphQLErrors[0].extensions.remainingCount+' ครั้ง)')
			} else {
				message.error(graphQLErrors[0].message)
			}
		}else if(graphQLErrors && graphQLErrors[0].extensions.code === 'INTERNAL_SERVER_ERROR'){
			alertMessage("error","พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ")
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else if(graphQLErrors && graphQLErrors[0].extensions.code === 'PROFILE_NOT_FOUND'){
			alertMessage("error","ไม่พบข้อมูล")
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else if(graphQLErrors && graphQLErrors[0].extensions.code === 'INVALID_PASSWORD_5_TIMES'){
			alertMessage("error", graphQLErrors[0].message)
			setTimeout(() => {
				clearAllStorage()
				window.location.href = '/login'
			}, 2000);
		}else{
			if(ErrorMessageFormAPIApollo(graphQLErrors[0])){
				alertMessage("error",ErrorMessageFormAPIApollo(graphQLErrors[0]))
				// message.error(ErrorMessageFormAPIApollo(graphQLErrors[0]))
			}else{
            alertMessage("error",graphQLErrors[0].message)
         }
		}
	}
})

const apolloClient = new ApolloClient({
	link: ApolloLink.from([errorLink, authLink, uploadLink]),
	cache: new InMemoryCache()
})
// cache-and-network
apolloClient.defaultOptions = {
	watchQuery: {
		fetchPolicy: 'no-cache',
      // fetchPolicy: 'cache-and-network',
		errorPolicy: 'ignore'
	},
	query: {
		fetchPolicy: 'no-cache',
      // fetchPolicy: 'cache-and-network',
		errorPolicy: 'all'
	}
}

export default apolloClient
